// extracted by mini-css-extract-plugin
export default {"container":"CompanyLogo_container__ueq5w","logo":"CompanyLogo_logo__7Pij8"};